import { useQuery } from 'wasp/client/operations';
import { getUserProfile } from 'wasp/client/operations';
import type { SubscriptionTier } from '../types/subscription';
import { normalizeTier, canAccess as canAccessTier, MAX_HOUSEHOLD_BY_TIER, isAIEnabled } from '../billing/tiers';

export function useTier() {
  const { data: userProfile } = useQuery(getUserProfile, {});

  const tier: SubscriptionTier = normalizeTier((userProfile as any)?.subscriptionTier);

  const canAccess = (requiredTier: SubscriptionTier) => canAccessTier(requiredTier, tier);

  const requiresUpgrade = (requiredTier: 'starter' | 'core_plus') => {
    return !canAccess(requiredTier);
  };

  // Specific limits
  const getHouseholdLimit = () => MAX_HOUSEHOLD_BY_TIER[tier] ?? 2;

  const canSaveRecipes = () => tier !== 'demo';
  const canGenerateShoppingLists = () => tier !== 'demo';
  const canUseAI = () => isAIEnabled(tier);
  const canGenerateMultiWeekPlans = () => tier !== 'demo';  // Demo limited to 7 days

  return {
    tier,
    canAccess,
    requiresUpgrade,
    householdLimit: getHouseholdLimit(),
    canSaveRecipes,
    canGenerateShoppingLists,
    canUseAI,
    canGenerateMultiWeekPlans,
  };
}
